import React from 'react';

export const usePassiveLayoutEffect =
	typeof document !== 'undefined' && document.createElement !== void 0 ? React.useLayoutEffect : React.useEffect;
